var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper is-flex is-flex-direction-column is-justify-content-center is-align-items-center flex-gap-10"},[_c('div',{staticClass:"title is-size-6"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"subtitle is-size-3",attrs:{"id":"number"}},[_vm._v(_vm._s(_vm.count))])])
}
var staticRenderFns = []

export { render, staticRenderFns }